import "core-js/modules/es.array.push.js";
import Highcharts from "highcharts/highstock";
import { Fold, Expand } from "@element-plus/icons-vue";
import { reactive, ref, onMounted } from "vue";
export default {
  components: {
    Fold,
    Expand
  },
  setup() {
    let tableData = reactive([{
      name: 11,
      level: 4,
      score: 1
    }]);
    let levelTableSwitch = ref(false);
    let levelTableData = [{
      level: 4,
      cesLevel: 4,
      test: "高考英语"
    }, {
      level: 5,
      cesLevel: 5,
      test: "大学英语六级/英语专业四级"
    }, {
      level: 6,
      cesLevel: 6,
      test: "英语专业八级"
    }, {
      level: 7,
      cesLevel: 7,
      test: "高考英语"
    }];
    let {
      menuStyle
    } = useMenu();
    useCharts();
    return {
      menuStyle,
      tableData,
      levelTableSwitch,
      levelTableData
    };
  }
};
function useMenu() {
  let menuStyle = reactive({
    width: "250px"
  });
  return {
    menuStyle
  };
}
//绘制图表
function useCharts() {
  //等级图表
  function levelCharts() {
    Highcharts.chart("level-box", {
      exporting: {
        enabled: false
      },
      chart: {
        type: "bar"
      },
      title: {
        text: " "
      },
      xAxis: [{
        visible: false
      }],
      yAxis: {
        min: 0,
        max: 100,
        visible: true,
        minorTickInterval: 10,
        tickPositioner: function () {
          var positions = [],
            tick = 0,
            increment = 10;
          for (tick; tick - increment < 100; tick += increment) {
            positions.push(tick);
          }
          return positions;
        },
        title: {
          text: "（百分位数%）"
        },
        plotBands: [{
          from: 0,
          // 标示带开始值
          to: 22,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "低水平",
            align: "center",
            x: -11,
            y: 12,
            verticalAlign: "middle",
            style: {
              fontSize: "12px",
              fontWeight: 600
            }
          },
          color: "#6EC8C8",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#6EC8C8" // 标示带边框颜色
        }, {
          from: 22,
          // 标示带开始值
          to: 77,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "中间水平",
            align: "right",
            x: -50,
            y: 12,
            verticalAlign: "middle",
            style: {
              fontSize: "12px",
              fontWeight: 700
            }
          },
          color: "#64ACCE",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#64ACCE" // 标示带边框颜色
        }, {
          from: 77,
          // 标示带开始值
          to: 100,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "高水平",
            x: -20,
            y: 12,
            verticalAlign: "middle",
            align: "right",
            style: {
              fontSize: "12px",
              fontWeight: 700
            }
          },
          color: "#4A95BD",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#4A95BD" // 标示带边框颜色
        }]
      },
      plotOptions: {
        series: {
          stacking: "normal"
        }
      },
      series: [{
        type: "spline",
        name: "所处位置",
        data: [1],
        marker: {
          enabled: true
          // symbol: 'url(image/report/sun.png)',
        }
      }]
    });
  }
  //横向图表
  function skillCharts() {
    Highcharts.chart("skill-bat-box", {
      exporting: {
        enabled: false
      },
      chart: {
        type: "bar",
        height: 140,
        spacingRight: 50,
        spacingTop: 35
      },
      legend: {
        enabled: true
      },
      title: {
        text: " "
      },
      xAxis: {
        categories: ["理解主旨大意", "获取细节信息", "做出一般推断", "理解句间关系", "理解说话者的意图、立场、态度、观点和情感"]
      },
      yAxis: {
        min: 0,
        max: 30,
        title: {
          text: "分数",
          align: "high"
        },
        labels: {
          overflow: "justify"
        }
      },
      tooltip: {
        valueSuffix: "分数"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            allowOverlap: true // 允许数据标签重叠
          }
        }
      },
      series: [{
        name: "得分",
        data: [0, 0, 0, 0, 0],
        color: "#82bee5"
      }]
    });
  }
  function genreCharts() {
    Highcharts.chart("genre-bat-box", {
      exporting: {
        enabled: false
      },
      chart: {
        type: "bar",
        height: 120
      },
      yAxis: [{
        min: 0,
        max: 100,
        visible: true,
        minorTickInterval: 10,
        tickPositioner: function () {
          var positions = [],
            tick = 0,
            increment = 10;
          for (tick; tick - increment < 100; tick += increment) {
            positions.push(tick);
          }
          return positions;
        },
        title: {
          text: "(百分位数%)",
          align: "high"
        },
        plotBands: [{
          from: 0,
          // 标示带开始值
          to: 22,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "低水平",
            align: "center",
            x: -11,
            y: 12,
            verticalAlign: "middle",
            style: {
              fontSize: "12px",
              fontWeight: 600
            }
          },
          color: "#6EC8C8",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#6EC8C8" // 标示带边框颜色
        }, {
          from: 22,
          // 标示带开始值
          to: 77,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "中间水平",
            align: "right",
            x: -50,
            y: 12,
            verticalAlign: "middle",
            style: {
              fontSize: "12px",
              fontWeight: 700
            }
          },
          color: "#64ACCE",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#64ACCE" // 标示带边框颜色
        }, {
          from: 77,
          // 标示带开始值
          to: 100,
          // 标示带结束值
          label: {
            // 标示带文字标签配置
            text: "高水平",
            x: -20,
            y: 12,
            verticalAlign: "middle",
            align: "right",
            style: {
              fontSize: "12px",
              fontWeight: 700
            }
          },
          color: "#4A95BD",
          // 标示带背景颜色
          borderWidth: 0,
          // 标示带边框宽度
          borderColor: "#4A95BD" // 标示带边框颜色
        }]
      }],
      xAxis: [{
        visible: false
      }],
      legend: {
        enabled: false,
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: "normal" // 开启堆叠,
        }
      },
      tooltip: {
        enabled: true,
        formatter: function () {
          return "超过<b>1%</b>";
        }
      },
      series: [{
        type: "spline",
        name: "所处位置",
        data: [22],
        marker: {
          enabled: true,
          symbol: "url(image/report/sun.png)"
        }
      }]
    });
  }
  onMounted(() => {
    //绘制
    levelCharts();
    skillCharts();
    genreCharts();
  });
  return {
    levelCharts,
    skillCharts
  };
}